<app-base-modal [modal]="modal">
  <ng-container modal-title>{{ 'general.announcements' | translate }}</ng-container>
  <ng-container modal-body>
    <div *ngFor="let announcement of announcementViews" class="d-flex align-items-start mb-3">
      <span aria-hidden [class]="announcement.iconClass + ' fa-2x mr-2 mt-1'"></span>
      <span class="fw-600">{{ announcement.message }}</span>
    </div>
  </ng-container>
  <ng-container modal-footer>
    <scw-mat-button type="cta" (onClick)="close()">{{ 'general.ok' | translate }}</scw-mat-button>
  </ng-container>
</app-base-modal>
